// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__32I_x","list":"PatternAutocomplete_list__2lbe5"};